import styled from 'styled-components';
import { theme } from '../../theme';
import { Card } from 'react-bootstrap';

export const DivWrapper = styled.div`
  width: 100%;
`;

const { colors } = theme;

export const AccordionCard = styled(Card)`
  &.user-management-accordion-card {
    border: none;
    margin-bottom: 2.5rem !important;
  }
`;

export const AccordionCardHeader = styled(Card.Header)`
  &.user-management-accordion-card-header {
    cursor: pointer !important;
    padding: 0 2.461rem !important;
    border: none;
    border-radius: 5px !important;
    background-color: ${colors.surfaceFront};
  }
`;

export const AccordionCardTitle = styled(Card.Title)`
  &.user-management-accordion-card-title {
    position: relative;
    margin: 0 !important;
    padding: 0 !important;
    font-size: 1.231rem !important;
    font-weight: 600 !important;
    color: ${colors.textPrimary} !important;
    line-height: 3.846rem;
    display: flex;
    justify-content: space-between;
    align-items: center;

    svg {
      font-size: 1.1rem;
    }

    &.is-collapsed {
      svg {
        transform: rotate(180deg);
      }
    }
  }
`;

export const SpanTitle = styled.span`
  margin-right: auto;
`;

export const DivSubAccount = styled.div`
  display: flex;
  align-items: center;
  padding: 0 2.461rem;

  &:first-of-type {
    margin-top: 0.8rem;
  }

  & > label {
    font-size: 1.078rem;
    font-weight: 500;
    line-height: 3rem;
    color: ${colors.textPrimary};
    align-items: center;
  }
`;
